<template>
    
  <div class="excel-comparator">
    <!-- Section d'import Excel -->
     <div  class="input-group input-group-sm mb-3">
        <button style="width: 150px;" @click="getArticles()" class="btn btn-outline-secondary" type="button" id="button-addon1">getmarque</button>
        <input v-model="marque"  class="form-control form-control-sm" type="text" >
    </div>
    <div  class="input-group input-group-sm mb-3">
            <input @change.prevent="addDateLivraison($event.target.value)"  class="form-control form-control-sm" type="date" >
        </div> 
    <div class="upload-section">
      <h3>1. Importer le fichier Excel</h3>
      <input 
        type="file" 
        accept=".xlsx, .xls" 
        @change="handleFileImport"
        class="file-input"
      />
      <p>Formats supportés: .xlsx, .xls</p>
    </div>

    <div v-if="loading" class="loading">
      Conversion et comparaison en cours...
    </div>

    <div v-if="error" class="error-message">
      {{ error }}
    </div>

    <!-- Résultats -->
    <div v-if="artExcel" class="results">
      <h3>2. Résultats de la conversion et comparaison</h3>
      
      <div class="stats">
        <div class="stat-card">
          <h4>Excel importé</h4>
          <p>Articles: {{ totalArticles }}</p>
          <p>Références: {{ totalReferences }}</p>
        </div>
        <div class="stat-card">
          <h4>Frep existant</h4>
          <p>Articles: {{ totalFrepArticles }}</p>
          <p>Références: {{ totalFrepReferences }}</p>
        </div>
        <div class="stat-card highlight">
          <h4>Correspondances</h4>
          <p>Articles: {{ matchingArticles.length }}</p>
          <p>Références: {{ uniqueMatchingReferences.length }}</p>
        </div>
      </div>

      <div class="actions">
        <button @click="downloadJSON" class="btn-primary">
          Télécharger artExcel JSON
        </button>
        <button @click="showPreview = !showPreview" class="btn-secondary">
          {{ showPreview ? 'Masquer' : 'Afficher' }} l'aperçu
        </button>
        <button @click="downloadComparison" class="btn-info">
          Télécharger comparaison CSV
        </button>
        <button @click="downloadNonMatching" class="btn-warning">
          Télécharger non correspondants
        </button>
      </div>

      <!-- Aperçu des données -->
      <div v-if="showPreview" class="preview-section">
        <div class="preview-tabs">
          <button 
            @click="activeTab = 'artExcel'" 
            :class="{ active: activeTab === 'artExcel' }"
          >
            artExcel ({{ totalArticles }})
          </button>
          <button 
            @click="activeTab = 'matching'" 
            :class="{ active: activeTab === 'matching' }"
          >
            Correspondances ({{ matchingArticles.length }})
          </button>
          <button 
            @click="activeTab = 'nonMatching'" 
            :class="{ active: activeTab === 'nonMatching' }"
          >
            Non correspondants ({{ nonMatchingArticles.length }})
          </button>
          <button 
            @click="activeTab = 'frep'" 
            :class="{ active: activeTab === 'frep' }"
          >
            Frep ({{ totalFrepArticles }})
          </button>
        </div>

        <div class="preview-content">
          <!-- Tab artExcel -->
          <div v-if="activeTab === 'artExcel'">
            <h4>Structure artExcel :</h4>
            <div class="data-table">
              <table>
                <thead>
                  <tr>
                    <th>codebarre</th>
                    <th>reference_y2</th>
                    <th>designation</th>
                    <th>code_taille</th>
                    <th>code_couleur</th>
                    <th>couleur</th>
                    <th>EAN13</th>
                    <th>code_theme</th>
                    <th>code_marque</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="article in allArticles" :key="article.EAN13">
                    <td>{{ article.codebarre }}</td>
                    <td>{{ article.reference_y2 }}</td>
                    <td>{{ article.designation }}</td>
                    <td>{{ article.code_taille }}</td>
                    <td>{{ article.code_couleur }}</td>
                    <td>{{ article.couleur }}</td>
                    <td>{{ article.EAN13 }}</td>
                    <td>{{ article.code_theme }}</td>
                    <td>{{ article.code_marque }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          
          <!-- Tab Correspondances -->
          <div v-if="activeTab === 'matching'">
            <h4>Articles trouvés dans Frep :</h4>
            <div class="data-table">
              <table>
                <thead>
                  <tr>
                    <th>codebarre</th>
                    <th>reference_y2</th>
                    <th>designation</th>
                    <th>code_taille</th>
                    <th>code_couleur</th>
                    <th>couleur</th>
                    <th>EAN13</th>
                    <th>DATE_LIVRAISON</th>
                    <th>Statut</th>
                    
                    
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    v-for="article in matchingArticles" 
                    :key="article.key"
                    class="matching-row"
                  >
                    <td>{{ article.frepMatch.codebarre }}</td>
                    <td>{{ article.frepMatch.reference_y2 }}</td>
                    <td>{{ article.frepMatch.designation }}</td>
                    <td>{{ article.frepMatch.code_taille }}</td>
                    <td>{{ article.frepMatch.code_couleur }}</td>
                    <td>{{ article.frepMatch.couleur }}</td>
                    <td>{{ article.frepMatch.EAN13 }}</td>
                    <td>{{ article.frepMatch.DATE_LIVRAISON }}</td>
                    
                    <td><span class="status-match">Correspondance</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          
          <!-- Tab Non correspondants -->
          <div v-if="activeTab === 'nonMatching'">
            <h4>Articles non trouvés dans Frep :</h4>
            <div class="data-table">
              <table>
                <thead>
                  <tr>
                    <th>codebarre</th>
                    <th>reference_y2</th>
                    <th>designation</th>
                    <th>code_taille</th>
                    <th>code_couleur</th>
                    <th>couleur</th>
                    <th>EAN13</th>
                    <th>code_theme</th>
                    <th>code_marque</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    v-for="article in nonMatchingArticles" 
                    :key="article.EAN13"
                    class="non-matching-row"
                  >
                    <td>{{ article.codebarre }}</td>
                    <td>{{ article.reference_y2 }}</td>
                    <td>{{ article.designation }}</td>
                    <td>{{ article.code_taille }}</td>
                    <td>{{ article.code_couleur }}</td>
                    <td>{{ article.couleur }}</td>
                    <td>{{ article.EAN13 }}</td>
                    <td>{{ article.code_theme }}</td>
                    <td>{{ article.code_marque }}</td>
                    
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          
          <!-- Tab Frep -->
          <!-- <div v-if="activeTab === 'frep'">
            <h4>Structure Frep :</h4>
            <div class="frep-structure">
              <div v-for="(marqueData, codemarque) in Frep" :key="codemarque" class="frep-level">
                <h5>code_marque: {{ codemarque }}</h5>
                <div v-for="(themeData, codeTheme) in marqueData" :key="codeTheme" class="frep-level">
                  <h6>code_theme: {{ codeTheme }}</h6>
                  <div v-for="(refData, refAdInt) in themeData" :key="refAdInt" class="frep-level">
                    <h6>reference_y2: {{ refAdInt }}</h6>
                    <div class="frep-articles">
                      <div v-for="(article, codebarre) in refData" :key="codebarre" class="frep-article">
                        <strong>{{ codebarre }}</strong>:
                        <ul>
                          <li>reference_y2: {{ article.reference_y2 }}</li>
                          <li>designation: {{ article.designation }}</li>
                          <li>code_taille: {{ article.code_taille }}</li>
                          <li>code_couleur: {{ article.code_couleur }}</li>
                          <li>couleur: {{ article.couleur }}</li>
                          <li>EAN13: {{ article.EAN13 }}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import * as XLSX from 'xlsx';
import axios from 'axios'
import store from './store';

// États réactifs
const loading = ref(false);
const error = ref('');
const artExcel = ref(null);
const showPreview = ref(false);
const activeTab = ref('artExcel');
function addDateLivraison (date){
    date=date.replace('-','').replace('-','').replace('-','')
    let datetab=store.state.dateLivraisons
    datetab.push(date)
    store.commit('addDateLivraison',datetab)
}
// Objet Frep avec le format spécifié
const Frep = ref({
  "217": {
    "CHAU1": {
      "39D-014950GT": {
        "CAB1": {
          "reference_y2": "39D-014950GT",
          "designation": "CHUNKY COMBAT CHELSEA MG MTR",
          "code_taille": "36",
          "EAN13": "8720109966572",
          "code_couleur": "0GT",
          "couleur": "Triple Black",
          "code_theme": "CHAU1",
          "code_marque": "217"
        },
        "CAB2": {
          "reference_y2": "39D-014950GT",
          "designation": "CHUNKY COMBAT CHELSEA MG MTR",
          "code_taille": "37",
          "EAN13": "8720109967524",
          "code_couleur": "0GT",
          "couleur": "Triple Black",
          "code_theme": "CHAU1",
          "code_marque": "217"
        },
        "CAB3": {
          "reference_y2": "39D-014950GT",
          "designation": "CHUNKY COMBAT CHELSEA MG MTR",
          "code_taille": "38",
          "EAN13": "8720109967586",
          "code_couleur": "0GT",
          "couleur": "Triple Black",
          "code_theme": "CHAU1",
          "code_marque": "217"
        }
      },
      "39D-014890GE": {
        "CAB8": {
          "reference_y2": "39D-014890GE",
          "designation": "BASKET CUPSOLE HIGH MIX ML MTR",
          "code_taille": "36",
          "EAN13": "8720109964370",
          "code_couleur": "0GE",
          "couleur": "Creamy White/Eggshell/Whisper Pink",
          "code_theme": "CHAU1",
          "code_marque": "217"
        }
      }
    },
    "CHAU2": {
      "39D-0086401W": {
        "CAB28": {
          "reference_y2": "39D-0086401W",
          "designation": "CLASSIC CUPSOLE LOW LACEUP LTH",
          "code_taille": "40",
          "EAN13": "8720109078848",
          "code_couleur": "01W",
          "couleur": "Bright White/Black",
          "code_theme": "CHAU2",
          "code_marque": "217"
        }
      }
    }
  }
});
let marque=ref()
watch(marque,()=>{
    store.commit('addmarque',marque.value)
})

// Computed properties
const allArticles = computed(() => {
  if (!artExcel.value) return [];
  return Object.values(artExcel.value);
});

const totalArticles = computed(() => {
  return allArticles.value.length;
});

const totalReferences = computed(() => {
  const refs = new Set();
  allArticles.value.forEach(article => {
    refs.add(article.reference_y2);
  });
  return refs.size;
});

const totalFrepArticles = computed(() => {
  return flattenFrepArticles.value.length;
});

const totalFrepReferences = computed(() => {
  const refs = new Set();
  flattenFrepArticles.value.forEach(article => {
    refs.add(article.reference_y2);
  });
  return refs.size;
});

// Aplatir la structure hiérarchique de Frep
const flattenFrepArticles = computed(() => {
  const articles = [];
  
  const processLevel = (obj) => {
    if (!obj || typeof obj !== 'object') return;
    
    // Si l'objet a reference_y2, c'est un article
    if (obj.reference_y2) {
      articles.push(obj);
    } else {
      // Sinon, parcourir les propriétés
      Object.values(obj).forEach(value => {
        processLevel(value);
      });
    }
  };
  
  processLevel(Frep.value);
  return articles;
});

const matchingArticles = computed(() => {
  return findMatchingArticles(artExcel.value, Frep.value);
});

const nonMatchingArticles = computed(() => {
  if (!artExcel.value) return [];
  const matchingKeys = new Set(matchingArticles.value.map(a => a.EAN13));
  return allArticles.value.filter(article => !matchingKeys.has(article.EAN13));
});

const uniqueMatchingReferences = computed(() => {
  const refs = new Set();
  matchingArticles.value.forEach(article => {
    refs.add(article.reference_y2);
  });
  return Array.from(refs);
});
// repart 
function parseChaineVersObjet(chaine) {
  const result = {};

  chaine.split(',').forEach(pair => {
    const [key, value] = pair.split(':').map(s => s.trim());
    if (key && value) {
      result[key] = Number(value);
    }
  });

  return result;
}

// Fonction de matching adaptée au format Frep
const findMatchingArticles = (artExcelData, frepData) => {
  if (!artExcelData || !frepData) return [];

  const matches = [];
  const frepArticles = flattenFrepArticles.value;
 let artObj=ref([])
  // Parcourir tous les articles Excel
  Object.entries(artExcelData).forEach(([codebarre, excelArticle]) => {
    const match = frepArticles.find(frepArticle => {
        // frepArticle.
      return (
        (frepArticle.reference_y2 == excelArticle.reference_y2  
        && String(frepArticle.taille) == String(excelArticle.taille) 
        && (frepArticle.code_couleur == excelArticle.code_couleur || frepArticle.couleur == excelArticle.couleur))
        ||frepArticle.ean13_y2 == excelArticle.ean13_y2 
      );
    });
    let datetab=store.state.dateLivraisons
    if(!datetab.find(el=> el==excelArticle.DATE_LIVRAISON)){
        datetab.push(excelArticle.DATE_LIVRAISON)
        store.commit('addDateLivraison',datetab)   
    }

    if (match) {
        matches.push({
        key: `${excelArticle.reference_y2}`,
        ...excelArticle,
        frepMatch: match
        })
        artObj.value.push( {...match,
            [excelArticle.DATE_LIVRAISON]:{qte:excelArticle.QTE_COMMANDE,export:false},
            repart:parseChaineVersObjet(excelArticle.repart),
            STATUT:'old' 
        });
    }else{
        artObj.value.push( {...match,
            ...excelArticle,
            [excelArticle.DATE_LIVRAISON]:{qte:excelArticle.QTE_COMMANDE,export:false},
            codebarre:excelArticle.ean13_y2,
            repart:parseChaineVersObjet(excelArticle.repart),
            STATUT:'new' 
        })
    }
  });
  
  artObj.value=convertTabToStructuredJSON(artObj.value)
  store.commit('addArticlesFrep',artObj.value[store.state.marque])
  
  
  return matches;
};
function excelDateToYYYYMMDD(excelDate) {
  // Excel commence au 1er janvier 1900
  const startDate = new Date(1900, 0, 1);

  // Excel compte le 29 février 1900 (qui n'a jamais existé), donc on retire 1 jour
  const realDate = new Date(startDate.getTime() + (excelDate - 2) * 86400000);

  const year = realDate.getFullYear();
  const month = String(realDate.getMonth() + 1).padStart(2, '0'); // getMonth() est 0-indexé
  const day = String(realDate.getDate()).padStart(2, '0');

  return `${year}${month}${day}`;
}

function convertirDate(dateStr) {
  const [jour, mois, annee] = dateStr.split('/');

  // Ajoute un zéro devant si nécessaire
  const j = jour.padStart(2, '0');
  const m = mois.padStart(2, '0');

  return `${annee}${m}${j}`;
}
// convertir 
function convertTabToStructuredJSON(tab) {
    const result = {};
    
    tab.forEach(item => {
        const {
            code_marque,
            code_theme,
            reference_y2,
            codebarre
        } = item;
        
        // Initialiser code_marque si n'existe pas
        if (!result[code_marque]) {
            result[code_marque] = {};
        }
        
        // Initialiser code_theme si n'existe pas
        if (!result[code_marque][code_theme]) {
            result[code_marque][code_theme] = {};
        }
        
        // Initialiser reference_y2 si n'existe pas
        if (!result[code_marque][code_theme][reference_y2]) {
            result[code_marque][code_theme][reference_y2] = {};
        }
        
        // Ajouter l'article avec codebarre comme clé
        result[code_marque][code_theme][reference_y2][codebarre] = { ...item };
    });
    
    return result;
}

// Import et conversion Excel
const handleFileImport = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  loading.value = true;
  error.value = '';

  try {
    const data = await readExcelFile(file);
    artExcel.value = convertToArtExcelFormat(data);
  } catch (err) {
    error.value = 'Erreur lors de la conversion: ' + err.message;
  } finally {
    loading.value = false;
  }
};

const readExcelFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        resolve(jsonData);
      } catch (err) {
        reject(err);
      }
    };
    
    reader.onerror = () => reject(new Error('Erreur de lecture du fichier'));
    reader.readAsArrayBuffer(file);
  });
};

const convertToArtExcelFormat = (excelData) => {
  const result = {};

  excelData.forEach(row => {
    const {
        acheteur,
        code_fourn,
        code_marque,
        marque,
        theme,
        code_theme,
        theme_AD_INT,
        ref_fourn,
        REF_AD_INT,
        code_couleur,
        LIB_couleur,
        taille_AD_INT,
        taille_FOURN,
        ORIGINEFAB,
        EAN13,
        poidsnet,
        SAISON,
        PRIX_ACHAT_$,
        PRIX_ACHAT_HT,
        REMISE_LIGNE,
        REMISE_PIED1,
        REMISE_PIED2,
        PRIX_PUBLIC_TTC,
        type_promo ,
        prix_promo,
        PRIX_NEGOCE,
        COMPOSITION,
        code_rayon,
        code_famille,
        CODE_SOUS_FAMILLE,
        designation_FR,
        TYPE_MARCHANDISE,
        pole,
        NOM_PRODUIT,
        dimensionS_LxHxP ,
        repartITION,
        DATE_LIVRAISON,
        QTE_COMMANDE,
        CATDOUANIE

    } = row;

    // Utiliser codebarre comme clé principale
    result[EAN13] = {
        acheteur:acheteur || '',
        code_fourn:code_fourn || '',
        code_marque:code_marque || '',
        marque:marque || '',
        theme:theme || '',
        code_theme:code_theme || '',
        theme:theme_AD_INT || '',
        ref_fourn:ref_fourn || '',
        reference_y2:REF_AD_INT || '',
        code_couleur:code_couleur || '',
        couleur:LIB_couleur || '',
        taille:taille_AD_INT || '',
        code_taille:taille_FOURN || '',
        code_paysorigine:ORIGINEFAB || '',
        ean13_y2:EAN13 || '',
        POIDSNET:poidsnet || '',
        collection:SAISON || '',
        achat_euro:PRIX_ACHAT_$ || '',
        achat_euro:PRIX_ACHAT_HT || '',
        REMISE_LIGNE:REMISE_LIGNE || '',
        REMISE_PIED1:REMISE_PIED1 || '',
        REMISE_PIED2:REMISE_PIED2 || '',
        vte_euro:PRIX_PUBLIC_TTC || '',
        type_promo: type_promo  || '',
        prix_promo:prix_promo || '',
        vte_negoce:PRIX_NEGOCE || '',
        code_composition:COMPOSITION || '',
        code_rayon:code_rayon || '',
        code_famille:code_famille || '',
        code_sousfamille:CODE_SOUS_FAMILLE || '',
        designation:designation_FR || '',
        GA_COMPTAARTICLE:TYPE_MARCHANDISE || '',
        code_pole:pole || '',
        ref_fourn:NOM_PRODUIT || '',
        dimension: dimensionS_LxHxP  || '',
        repart:repartITION  || '',
        DATE_LIVRAISON:DATE_LIVRAISON  || '',
        QTE_COMMANDE:QTE_COMMANDE  || '',
        code_catdouanie:CATDOUANIE  || ''

    };
  });

  return result;
};

// Téléchargements
const downloadJSON = () => {
  if (!artExcel.value) return;
  const dataStr = JSON.stringify(artExcel.value, null, 2);
  downloadFile(dataStr, 'artExcel.json', 'application/json');
};

const downloadComparison = () => {
  const csvData = convertToCSV(matchingArticles.value);
  downloadFile(csvData, 'correspondances.csv', 'text/csv');
};

const downloadNonMatching = () => {
  const csvData = convertToCSV(nonMatchingArticles.value);
  downloadFile(csvData, 'non_correspondants.csv', 'text/csv');
};

const convertToCSV = (data) => {
  if (!data.length) return 'Aucune donnée';
  
  // Exclure les objets complexes de l'export CSV
  const safeData = data.map(item => {
    const safeItem = { ...item };
    delete safeItem.frepMatch;
    delete safeItem.key;
    return safeItem;
  });
  
  const headers = Object.keys(safeData[0]);
  const csv = [
    headers.join(','),
    ...safeData.map(row => 
      headers.map(header => {
        const value = row[header] || '';
        return `"${value.toString().replace(/"/g, '""')}"`;
      }).join(',')
    )
  ].join('\n');
  
  return '\uFEFF' + csv; // BOM pour Excel
};

const downloadFile = (dataStr, filename, mimeType) => {
  const dataBlob = new Blob([dataStr], { type: mimeType });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(dataBlob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
};
async function getArticles(){
        // colorsToAddTab.value=[]
        // colorsToAddTabFilter.value=[]
        // colorsToAddTabFilterSelected.value=[]
        // taillesToAddTab.value=[]
        // taillesToAddTabFilter.value=[]
        // taillesToAddTabFilterSelected.value=[]
        // store.commit('updateWaiting')
        let params=
        {   
            marques:`{${store.state.marque}}`
        }
        let url=    `https://my.edisac.com/goapi/articlesdeep`
        let config = {
        method: 'get',
        url: url,
        params:params
        };
        return   axios.request(config)
        .then((response) => {
            //console.log(response.data);
            Frep.value=response.data.articles
            // store.commit('addArticles',response.data.articles) 
            // taillesToAddTab.value=response.data.taillesToAddTab
            // colorsToAddTab.value=response.data.colorsToAddTab
            // taillesToAddTabFilter.value=response.data.taillesToAddTab.sort((a,b)=>{ return a.code_taille-b.code_taille})
            // colorsToAddTabFilter.value=response.data.colorsToAddTab.sort((a,b)=>{ return a.couleur-b.couleur})
            // maxcouleur.value=response.data.maxcouleur
            // ean13Tab.value=response.data.ean13Tab
            // store.commit('updateWaiting')
        })
        .catch((error) => {
        //console.log(error);
        });
        
    }

// Chargement initial
onMounted(() => {
    getArticles()
//   //console.log('Composant monté, Frep chargé:', Frep.value);
//   //console.log('Articles Frep aplatis:', flattenFrepArticles.value);
});
</script>

<style scoped>
.excel-comparator {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}

.upload-section {
  border: 2px dashed #007bff;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  margin-bottom: 30px;
  background: #f8f9fa;
}

.file-input {
  margin: 15px 0;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.loading {
  text-align: center;
  padding: 20px;
  color: #007bff;
  font-size: 18px;
  background: #e3f2fd;
  border-radius: 8px;
  margin: 20px 0;
}

.error-message {
  color: #dc3545;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  padding: 12px;
  border-radius: 4px;
  margin: 20px 0;
}

.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin: 30px 0;
}

.stat-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  text-align: center;
  border: 1px solid #e9ecef;
}

.stat-card.highlight {
  background: #e3f2fd;
  border: 2px solid #2196f3;
}

.actions {
  display: flex;
  gap: 12px;
  margin: 25px 0;
  flex-wrap: wrap;
}

.btn-primary, .btn-secondary, .btn-info, .btn-warning {
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.btn-primary { background-color: #007bff; color: white; }
.btn-secondary { background-color: #6c757d; color: white; }
.btn-info { background-color: #17a2b8; color: white; }
.btn-warning { background-color: #ffc107; color: #212529; }

.preview-section {
  margin-top: 30px;
}

.preview-tabs {
  display: flex;
  border-bottom: 2px solid #dee2e6;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.preview-tabs button {
  padding: 12px 20px;
  border: none;
  background: none;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  font-size: 14px;
}

.preview-tabs button.active {
  border-bottom-color: #007bff;
  color: #007bff;
  font-weight: bold;
  background: #f8f9fa;
}

.preview-content {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  max-height: 600px;
  overflow-y: auto;
}

.data-table {
  overflow-x: auto;
}

.data-table table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  font-size: 12px;
}

.data-table th,
.data-table td {
  padding: 8px 6px;
  text-align: left;
  border-bottom: 1px solid #dee2e6;
}

.data-table th {
  background-color: #343a40;
  color: white;
  font-weight: 600;
  white-space: nowrap;
}

.data-table tr:hover {
  background-color: #f8f9fa;
}

.matching-row {
  background-color: #d4edda !important;
}

.non-matching-row {
  background-color: #f8d7da !important;
}

.status-match {
  background: #28a745;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
}

.frep-structure {
  font-family: monospace;
  font-size: 12px;
}

.frep-level {
  margin-left: 20px;
  margin-bottom: 10px;
  padding: 10px;
  border-left: 2px solid #dee2e6;
}

.frep-level h5, .frep-level h6 {
  margin: 5px 0;
  color: #495057;
}

.frep-articles {
  margin-left: 10px;
}

.frep-article {
  background: white;
  padding: 8px;
  margin: 5px 0;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.frep-article ul {
  margin: 5px 0;
  padding-left: 20px;
}

.frep-article li {
  margin: 2px 0;
}

@media (max-width: 768px) {
  .stats {
    grid-template-columns: 1fr;
  }
  
  .actions {
    flex-direction: column;
  }
  
  .preview-tabs {
    flex-direction: column;
  }
  
  .data-table {
    font-size: 10px;
  }
}
</style>